import _ from 'lodash'
import { RootState } from '../../types/RootState'

class CompanyPlanningRecordSelectors {
  getCompanyPlanningRecord = _.memoize(
    ({ companyPlanningRecordId }: { companyPlanningRecordId: string }) =>
      (state: RootState) =>
        state.companyPlanningRecord.companyPlanningRecord?.id === companyPlanningRecordId
          ? state.companyPlanningRecord.companyPlanningRecord
          : undefined,
    ({ companyPlanningRecordId }) => companyPlanningRecordId,
  )
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.companyPlanningRecord.status === 'initial' ||
            state.companyPlanningRecord.status === 'loading'
          : state.companyPlanningRecord.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  getInitial = (state: RootState) => state.companyPlanningRecord.status === 'initial'
  getHasError = (state: RootState) => state.companyPlanningRecord.status === 'failed'
  getError = (state: RootState) => state.companyPlanningRecord.error
}

export default new CompanyPlanningRecordSelectors()
